import { Company } from "./company";

export class Job {
  id = 0;
  job_No = '';
  contract_No = '';
  start_Time;
  end_Time;
  travel_Time;
  week_Commencing;

  site_Id: number = 0;
  engineer_Id: number = 0;
  completed: Boolean = false
  inspection_Colour: number = 0;
  mileage: number = 0;



  company: Company;

  is_edit: Boolean = false;


  selectedIds: [];
}
